<template>
  <b-card class="card-contractor-garden-help mt-0 h-100" header-class="mt-3" no-body>

    <template #header>
      <!-- <h4 class="mb-0">Hello World</h4> -->
      <router-link :to="'/garden_help/contractor_profile/' + contractor.id" target="_blank">
        <b-row class="justify-content-center">
          <b-col xl="2" lg="3" md="2" cols="3" class="position-relative p-0"><img
              src="@/assets/images/garden-help/user-icon.png" />
          </b-col>
          <b-col xl="6" lg="6" md="6" cols="9" class="py-1 ">
            <!-- <b-row :cols="job.contractor ? '2' : '1'"
              ><b-col class="p-1"> -->
            <b-card-sub-title>Contractor</b-card-sub-title>
            <b-card-title>{{ contractor.name }}</b-card-title>
            <!-- </b-col> -->
            <!-- <b-col class="p-1" v-if="job.contractor">
                <b-card-sub-title>Contractor</b-card-sub-title>
                <b-card-title>{{ job.contractor }}</b-card-title>
              </b-col> -->
            <!-- </b-row> -->
          </b-col>
        </b-row>
      </router-link>
    </template>

    <b-card-body class="mt-2 py-0 ">
      <h5 class="list-title">Service Details</h5>
      <b-list-group class="servies-list">
        <b-list-group-item class="servies-list-item" v-for="(service, index) in contractor.services.slice(0, length)"
          :key="index">
          <span class="check-span">
            <font-awesome-icon icon="fa-solid fa-circle-check" /></span>
          <p>{{ service.name }}</p>
        </b-list-group-item>
      </b-list-group><b-button v-if="contractor.services.length > length" variant="garden-help-primary-link"
        class="btn-bumblebee btn-garden-help view-more-action" @click="clickViewMore">+ {{ contractor.services.length -
          length }} more</b-button>
      <b-button v-if="contractor.services.length > max_length && contractor.services.length == length"
        variant="garden-help-primary-link" class="btn-bumblebee btn-garden-help view-more-action" @click="clickViewLess">-
        View less</b-button>
    </b-card-body>

    <b-card-footer>
      <div>
        <img :src="img_src" alt="image" />
        <b-row class="mx-auto"><b-col>
            <!-- <b-button type="button" variant="garden-help-secondary"
              class="btn-bumblebee btn-garden-help mb-1 mx-auto w-100">Request a quote</b-button> -->
            <router-link :to="'/garden_help/jobs/add_job/' + contractor.id + '?services=' + services_ids"
              class="btn btn-bumblebee btn-garden-help btn-garden-help-secondary mb-1 mx-auto w-100">
              Request a quote
            </router-link>
          </b-col></b-row>
      </div>
    </b-card-footer>
  </b-card>
</template>
  
<script>
import $ from "jquery";
import moment from "moment";

export default {
  name: "ContractorCardFindContractors",
  components: {},
  props: ["contractor"],
  data() {
    return {
      img_src: require('@/assets/images/garden-help/Logo.png'),
      length: 3,
      max_length: 3,
      services_ids: []
    }
  },
  mounted() {
    console.log(this.contractor.media)
    // company_image
    let images =  this.contractor.media.filter((v) => v.media_type == 'company_image')
    console.log(images)

    this.img_src = images != null && images.length > 0 ? images[0].path : require('@/assets/images/garden-help/Logo.png')

    this.services_ids = []
    for (let i = 0; i < this.contractor.services.length; i++) {
      this.services_ids.push(this.contractor.services[i].id)
    }
  },
  methods: {
    clickViewMore() {
      this.length = this.contractor.services.length;
    },
    clickViewLess() {
      this.length = this.max_length;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/contractor_card/FindContractor.vue